export const servicesData = [
  {
    id: 1,
    slug: 'web-development',
    title: 'Web Development',
    subtitle: 'Custom websites and web applications built with modern technologies',
    description: 'We create powerful, scalable websites and web applications using cutting-edge technologies like React, Next.js, and Node.js. Our development approach focuses on performance, security, and user experience.',
    icon: 'FiCode',
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&h=600&fit=crop',
    overview: 'Transform your digital presence with custom web development solutions that drive results. We specialize in creating fast, secure, and scalable websites that not only look great but perform exceptionally well.',
    benefits: [
      'Lightning-fast loading speeds for better user experience',
      'Mobile-responsive design that works on all devices',
      'SEO-optimized structure for better search rankings',
      'Secure coding practices to protect your business',
      'Scalable architecture that grows with your business',
      'Easy-to-use content management systems'
    ],
    process: [
      {
        step: 1,
        title: 'Discovery & Planning',
        description: 'We analyze your business needs, target audience, and technical requirements to create a comprehensive development strategy.'
      },
      {
        step: 2,
        title: 'Design & Architecture',
        description: 'Our team designs the user interface and system architecture, ensuring optimal performance and user experience.'
      },
      {
        step: 3,
        title: 'Development & Testing',
        description: 'We build your website using modern technologies, conducting thorough testing throughout the development process.'
      },
      {
        step: 4,
        title: 'Launch & Support',
        description: 'After deployment, we provide ongoing maintenance, updates, and technical support to keep your site running smoothly.'
      }
    ],
    technologies: [
      'React & Next.js',
      'Node.js & Express',
      'WordPress & Custom CMS',
      'E-commerce Platforms',
      'Database Design',
      'API Integration',
      'Cloud Hosting',
      'Security Implementation'
    ],
    pricing: {
      startingPrice: 'From £600',
      packages: [
        {
          name: 'Basic Website',
          price: '',
          features: [
            'Up to 5 pages',
            'Mobile responsive design',
            'Basic SEO setup',
            'Contact form integration',
            'SSL certificate',
            '3 months support'
          ]
        },
        {
          name: 'Professional Website',
          price: '',
          features: [
            'Up to 15 pages',
            'Custom design & branding',
            'Advanced SEO optimization',
            'CMS integration',
            'E-commerce capability',
            '6 months support'
          ]
        },
        {
          name: 'Enterprise Solution',
          price: '',
          features: [
            'Unlimited pages',
            'Custom functionality',
            'API integrations',
            'Performance optimization',
            'Security hardening',
            '12 months support'
          ]
        }
      ]
    },
    projects: [
      {
        slug: 'domestic-appliance-repairz-website',
        title: 'Domestic Appliance Repairz',
        category: 'Trade Website',
        image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&h=400&fit=crop',
        result: '150% increase in enquiries within 2 months of launch',
        tech: ['WordPress', 'Local SEO', 'Booking System']
      },
      {
        slug: 'shieldflare-website',
        title: 'Shieldflare',
        category: 'Cybersecurity SaaS Website',
        image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop',
        result: 'Successfully positioned Shieldflare as a credible cybersecurity SaaS provider',
        tech: ['React', 'Portfolio System', 'SEO']
      },
      {
        slug: 'tappr-website',
        title: 'Tappr Digital',
        category: 'Transportation Website',
        image: 'https://images.unsplash.com/photo-1455641374154-422f32e234cd?w=600&h=400&fit=crop',
        result: 'Business doubled in 6 months',
        tech: ['.NET Core', 'React', 'Booking System', 'CRM Integration']
      }
    ]
  },
  {
    id: 2,
    slug: 'digital-marketing',
    title: 'Digital Marketing',
    subtitle: 'Data-driven marketing strategies that increase your online presence',
    description: 'Boost your online visibility and drive qualified leads with our comprehensive digital marketing services. We combine SEO, PPC, social media, and content marketing to deliver measurable results.',
    icon: 'FiTrendingUp',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
    overview: 'Accelerate your business growth with strategic digital marketing campaigns that target the right audience at the right time. Our data-driven approach ensures maximum ROI on your marketing investment.',
    benefits: [
      'Increased website traffic from targeted audiences',
      'Higher conversion rates and lead generation',
      'Improved brand visibility and recognition',
      'Better customer engagement and retention',
      'Measurable results with detailed analytics',
      'Cost-effective compared to traditional advertising'
    ],
    process: [
      {
        step: 1,
        title: 'Market Analysis',
        description: 'We research your industry, competitors, and target audience to identify the best marketing opportunities.'
      },
      {
        step: 2,
        title: 'Strategy Development',
        description: 'Our team creates a comprehensive marketing strategy tailored to your business goals and budget.'
      },
      {
        step: 3,
        title: 'Campaign Implementation',
        description: 'We execute multi-channel campaigns across search engines, social media, and other relevant platforms.'
      },
      {
        step: 4,
        title: 'Optimization & Reporting',
        description: 'Continuous monitoring and optimization of campaigns with regular performance reports and insights.'
      }
    ],
    technologies: [
      'Google Ads & Analytics',
      'Facebook Business Manager',
      'SEO Tools & Software',
      'Email Marketing Platforms',
      'Content Management Systems',
      'Social Media Schedulers',
      'Conversion Tracking',
      'Marketing Automation'
    ],
    pricing: {
      startingPrice: 'From £800/month',
      packages: [
        {
          name: 'Local SEO Package',
          price: '',
          features: [
            'Local keyword optimization',
            'Google My Business setup',
            'Local directory listings',
            'Monthly reporting',
            'Review management',
            'Basic content creation'
          ]
        },
        {
          name: 'Growth Marketing',
          price: '',
          features: [
            'Comprehensive SEO strategy',
            'PPC campaign management',
            'Social media marketing',
            'Content marketing',
            'Email campaigns',
            'Advanced analytics'
          ]
        },
        {
          name: 'Enterprise Marketing',
          price: '',
          features: [
            'Multi-channel campaigns',
            'Advanced automation',
            'Custom analytics dashboards',
            'Dedicated account manager',
            'Strategic consultancy',
            'Priority support'
          ]
        }
      ]
    },
    projects: [
      {
        slug: 'domestic-appliance-repairz-website',
        title: 'Domestic Appliance Repairz',
        category: 'Local SEO Campaign',
        image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&h=400&fit=crop',
        result: '400% increase in emergency call-outs',
        tech: ['Local SEO', 'Google My Business', 'PPC']
      },
      {
        slug: 'al-quds-acadnemy-website',
        title: 'Al-Quds Academy',
        category: 'Content Marketing',
        image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=600&h=400&fit=crop',
        result: '60% increase in project value',
        tech: ['Content Strategy', 'Social Media', 'SEO']
      },
      {
        slug: 'auk-airport-service-website',
        title: 'AUK Airport Service',
        category: 'Local SEO Campaign',
        image: 'https://images.unsplash.com/photo-1609510889785-739484fab5f3?h=400&fit=crop',
        result: 'Increased online bookings and reduced reliance on phone calls',
        tech: ['Google Ads', 'Landing Pages', 'Conversion Tracking']
      }
    ]
  },
  {
    id: 3,
    slug: 'brand-design',
    title: 'Brand Design',
    subtitle: 'Creative branding solutions that capture your unique identity',
    description: 'Create a memorable brand identity that resonates with your audience and sets you apart from competitors. Our design services cover everything from logos to complete brand guidelines.',
    icon: 'FiPenTool',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop',
    overview: 'Build a strong, recognizable brand that connects with your customers and drives business growth. Our creative team develops cohesive brand identities that work across all touchpoints.',
    benefits: [
      'Professional brand identity that builds trust',
      'Consistent visual presence across all platforms',
      'Increased brand recognition and recall',
      'Differentiation from competitors',
      'Enhanced customer perception and loyalty',
      'Scalable design systems for future growth'
    ],
    process: [
      {
        step: 1,
        title: 'Brand Discovery',
        description: 'We explore your business values, target audience, and competitive landscape to understand your brand positioning.'
      },
      {
        step: 2,
        title: 'Concept Development',
        description: 'Our designers create initial concepts and mood boards that capture your brand personality and vision.'
      },
      {
        step: 3,
        title: 'Design Refinement',
        description: 'We refine the chosen concepts, developing logos, color palettes, typography, and visual elements.'
      },
      {
        step: 4,
        title: 'Brand Guidelines',
        description: 'Complete brand guidelines are created to ensure consistent application across all marketing materials.'
      }
    ],
    technologies: [
      'Adobe Creative Suite',
      'Figma & Sketch',
      'Brand Identity Systems',
      'Typography Design',
      'Color Theory Application',
      'Print Design Standards',
      'Digital Asset Creation',
      'Brand Guideline Development'
    ],
    pricing: {
      startingPrice: 'From £1,200',
      packages: [
        {
          name: 'Logo & Identity',
          price: '',
          features: [
            'Logo design concepts',
            'Brand color palette',
            'Typography selection',
            'Business card design',
            'Basic brand guidelines',
            '3 revision rounds'
          ]
        },
        {
          name: 'Complete Brand Package',
          price: '',
          features: [
            'Comprehensive brand strategy',
            'Logo and visual identity',
            'Marketing materials design',
            'Website integration',
            'Brand guidelines document',
            'Unlimited revisions'
          ]
        },
        {
          name: 'Enterprise Branding',
          price: '',
          features: [
            'Full brand audit and strategy',
            'Complete visual identity system',
            'Brand application across all media',
            'Team training and workshops',
            'Ongoing brand support',
            'Strategic brand consultancy'
          ]
        }
      ]
    },
    projects: [
      {
        slug: 'tappr-website',
        title: 'Tappr Digital',
        category: 'Transportation Branding',
        image: 'https://images.unsplash.com/photo-1455641374154-422f32e234cd?w=600&h=400&fit=crop',
        result: 'Complete brand transformation',
        tech: ['Logo Design', 'Brand Guidelines', 'Marketing Materials']
      },
      {
        slug: 'shieldflare-website',
        title: 'Shieldflare',
        category: 'Creative Branding',
        image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop',
        result: 'Improved clarity of messaging for technical and non-technical audiences',
        tech: ['Visual Identity', 'Photography Direction', 'Marketing Collateral']
      },
    ]
  },
  {
    id: 4,
    slug: 'mobile-solutions',
    title: 'Mobile Solutions',
    subtitle: 'Native and cross-platform mobile applications',
    description: 'Extend your business reach with custom mobile applications that provide exceptional user experiences on iOS and Android devices.',
    icon: 'FiSmartphone',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=600&fit=crop',
    overview: 'Engage your customers wherever they are with powerful mobile applications that deliver seamless experiences and drive business growth.',
    benefits: [
      'Direct access to customers on their mobile devices',
      'Enhanced customer engagement and loyalty',
      'Push notifications for real-time communication',
      'Offline functionality for uninterrupted service',
      'Integration with device features (camera, GPS, etc.)',
      'App store presence for increased visibility'
    ],
    process: [
      {
        step: 1,
        title: 'Requirements Analysis',
        description: 'We analyze your business needs and define the mobile app functionality and user experience requirements.'
      },
      {
        step: 2,
        title: 'UI/UX Design',
        description: 'Our designers create intuitive interfaces that provide excellent user experiences on mobile devices.'
      },
      {
        step: 3,
        title: 'Development & Testing',
        description: 'We develop your app using modern frameworks, conducting thorough testing on multiple devices and platforms.'
      },
      {
        step: 4,
        title: 'App Store Deployment',
        description: 'We handle the app store submission process and provide ongoing maintenance and updates.'
      }
    ],
    technologies: [
      'React Native',
      'Flutter Development',
      'iOS Swift',
      'Android Kotlin',
      'Progressive Web Apps',
      'API Integration',
      'Push Notifications',
      'App Store Optimization'
    ],
    pricing: {
      startingPrice: 'From £8,000',
      packages: [
        {
          name: 'Simple App',
          price: '',
          features: [
            'Basic functionality',
            'Single platform (iOS or Android)',
            'Simple user interface',
            'Basic backend integration',
            'App store submission',
            '3 months support'
          ]
        },
        {
          name: 'Business App',
          price: '',
          features: [
            'Advanced features',
            'Cross-platform development',
            'Custom UI/UX design',
            'API integrations',
            'Push notifications',
            '6 months support'
          ]
        },
        {
          name: 'Enterprise App',
          price: '',
          features: [
            'Complex functionality',
            'Multiple platforms',
            'Advanced security features',
            'Third-party integrations',
            'Ongoing maintenance',
            '12 months support'
          ]
        }
      ]
    },
    projects: []
  },
  {
    id: 5,
    slug: 'e-commerce',
    title: 'E-commerce Solutions',
    subtitle: 'Complete online stores with payment processing and inventory management',
    description: 'Launch your online store with our comprehensive e-commerce solutions. From product catalogs to secure payment processing, we handle every aspect of your digital storefront.',
    icon: 'FiShoppingCart',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop',
    overview: 'Transform your retail business with powerful e-commerce platforms that drive sales and provide exceptional shopping experiences for your customers.',
    benefits: [
      'Secure payment processing and checkout',
      'Inventory management and order tracking',
      'Mobile-optimized shopping experience',
      'SEO-friendly product pages',
      'Integration with shipping providers',
      'Customer account management'
    ],
    process: [
      {
        step: 1,
        title: 'Store Planning',
        description: 'We analyze your products, target market, and business goals to plan the optimal e-commerce solution.'
      },
      {
        step: 2,
        title: 'Platform Setup',
        description: 'Our team sets up your e-commerce platform with custom design and essential functionality.'
      },
      {
        step: 3,
        title: 'Product Integration',
        description: 'We help you upload products, configure pricing, and set up inventory management systems.'
      },
      {
        step: 4,
        title: 'Launch & Optimization',
        description: 'After launch, we provide training and ongoing optimization to maximize your online sales.'
      }
    ],
    technologies: [
      'Shopify Development',
      'WooCommerce',
      'Magento Solutions',
      'Custom E-commerce',
      'Payment Gateway Integration',
      'Inventory Management',
      'Shipping Integration',
      'Analytics & Reporting'
    ],
    pricing: {
      startingPrice: 'From £3,500',
      packages: [
        {
          name: 'Starter Store',
          price: '',
          features: [
            'Up to 50 products',
            'Basic e-commerce functionality',
            'Payment gateway setup',
            'Mobile responsive design',
            'Basic SEO optimization',
            '3 months support'
          ]
        },
        {
          name: 'Professional Store',
          price: '',
          features: [
            'Up to 500 products',
            'Advanced e-commerce features',
            'Custom design and branding',
            'Inventory management',
            'Marketing integrations',
            '6 months support'
          ]
        },
        {
          name: 'Enterprise Store',
          price: '',
          features: [
            'Unlimited products',
            'Custom functionality',
            'Multi-channel selling',
            'Advanced analytics',
            'Third-party integrations',
            '12 months support'
          ]
        }
      ]
    },
    projects: []
  },
  {
    id: 6,
    slug: 'consulting',
    title: 'Digital Consulting',
    subtitle: 'Strategic technology consulting for informed digital decisions',
    description: 'Get expert guidance on your digital transformation journey. Our consultants help you make informed decisions about technology investments and digital strategy.',
    icon: 'FiSettings',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop',
    overview: 'Navigate the complex digital landscape with confidence. Our experienced consultants provide strategic guidance to help you achieve your business objectives through technology.',
    benefits: [
      'Expert analysis of your current digital presence',
      'Strategic roadmap for digital transformation',
      'Technology recommendations tailored to your needs',
      'Process optimization and efficiency improvements',
      'Risk assessment and mitigation strategies',
      'Training and knowledge transfer'
    ],
    process: [
      {
        step: 1,
        title: 'Current State Analysis',
        description: 'We conduct a comprehensive audit of your existing digital infrastructure and processes.'
      },
      {
        step: 2,
        title: 'Strategy Development',
        description: 'Our consultants develop a tailored digital strategy aligned with your business objectives.'
      },
      {
        step: 3,
        title: 'Implementation Planning',
        description: 'We create detailed implementation plans with timelines, resources, and success metrics.'
      },
      {
        step: 4,
        title: 'Ongoing Support',
        description: 'Continuous guidance and support throughout your digital transformation journey.'
      }
    ],
    technologies: [
      'Technology Assessment',
      'Digital Strategy Planning',
      'Process Optimization',
      'Security Auditing',
      'Performance Analysis',
      'Team Training',
      'Change Management',
      'ROI Analysis'
    ],
    pricing: {
      startingPrice: 'From £150/hour',
      packages: [
        {
          name: 'Digital Audit',
          price: '',
          features: [
            'Comprehensive website audit',
            'Technology stack review',
            'Performance analysis',
            'Security assessment',
            'Recommendations report',
            'Action plan development'
          ]
        },
        {
          name: 'Strategic Consulting',
          price: '',
          features: [
            'One-on-one consultations',
            'Strategic planning sessions',
            'Technology recommendations',
            'Implementation guidance',
            'Team training',
            'Ongoing support'
          ]
        },
        {
          name: 'Transformation Project',
          price: '',
          features: [
            'Complete digital strategy',
            'Implementation roadmap',
            'Project management',
            'Team training program',
            'Change management',
            '6 months support'
          ]
        }
      ]
    },
    projects: []
  }
];

export const getServiceBySlug = (slug) => {
  return servicesData.find(service => service.slug === slug);
};